// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.test_instance_creation_source_enum */
var TestInstanceCreationSourceEnum;
(function (TestInstanceCreationSourceEnum) {
    TestInstanceCreationSourceEnum["LOCAL"] = "LOCAL";
    TestInstanceCreationSourceEnum["REQUEST"] = "REQUEST";
    TestInstanceCreationSourceEnum["IMPORT"] = "IMPORT";
    TestInstanceCreationSourceEnum["LEGACY"] = "LEGACY";
    TestInstanceCreationSourceEnum["PLAN"] = "PLAN";
})(TestInstanceCreationSourceEnum || (TestInstanceCreationSourceEnum = {}));
;
export default TestInstanceCreationSourceEnum;
/** Zod schema for test_instance_creation_source_enum */
export const testInstanceCreationSourceEnum = z.nativeEnum(TestInstanceCreationSourceEnum);
//# sourceMappingURL=TestInstanceCreationSourceEnum.js.map